module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-campaign-initial-data pt-0"
  }, [_c('div', {
    staticClass: "header-div",
    attrs: {
      "id": "header-div"
    }
  }, [_c('v-row', {
    staticClass: "py-2"
  }, [_c('v-col', {
    staticClass: "py-0 px-0",
    class: _vm.display === 'xs' || _vm.display === 'sm' ? 'text-center' : '',
    attrs: {
      "cols": "12"
    }
  }, [(_vm.display === 'xs' || _vm.display === 'sm') ? _c('div', {
    staticClass: "d-flex flex-column align-center"
  }, [_c('h3', {
    staticClass: "header-main py-1"
  }, [_c('span', {
    staticClass: "bold-title"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.serviceOnboardingTitle')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$store.getters.userOrganization.name))])]), _vm._v(" "), _c('div', {
    staticClass: "save-status-indicator mt-2"
  }, [(_vm.saveStatus === 'saving') ? _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-icon', {
    staticClass: "save-icon saving mr-1"
  }, [_vm._v("mdi-refresh")]), _vm._v(" "), _c('span', {
    staticClass: "save-text"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.saving')))])], 1) : (_vm.saveStatus === 'saved') ? _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-icon', {
    staticClass: "save-icon saved mr-1"
  }, [_vm._v("mdi-cloud-check-outline")]), _vm._v(" "), _c('span', {
    staticClass: "save-text"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.changesSaved')))])], 1) : _vm._e()])]) : _c('div', {
    staticClass: "d-flex align-center justify-space-between"
  }, [_c('h3', {
    staticClass: "header-main py-3"
  }, [_c('span', {
    staticClass: "bold-title"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.serviceOnboardingTitle')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$store.getters.userOrganization.name))])]), _vm._v(" "), _c('div', {
    staticClass: "save-status-indicator"
  }, [(_vm.saveStatus === 'saving') ? _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-icon', {
    staticClass: "save-icon saving mr-1"
  }, [_vm._v("mdi-refresh")]), _vm._v(" "), _c('span', {
    staticClass: "save-text"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.saving')))])], 1) : (_vm.saveStatus === 'saved') ? _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-icon', {
    staticClass: "save-icon saved mr-1"
  }, [_vm._v("mdi-cloud-check-outline")]), _vm._v(" "), _c('span', {
    staticClass: "save-text"
  }, [_vm._v(_vm._s(_vm.$t('NewCampaignInitialData.changesSaved')))])], 1) : _vm._e()])])])], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), (_vm.campaign) ? _c('div', {
    staticClass: "new-campaign-content"
  }, [_c('NewCampaignIntroduction', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === _vm.CAMPAIGN_STEPS.INTRODUCTION),
      expression: "currentStep === CAMPAIGN_STEPS.INTRODUCTION"
    }],
    attrs: {
      "nextStep": _vm.nextStep,
      "products": _vm.products,
      "campaignId": _vm.campaignId
    }
  }), _vm._v(" "), _c('NewCampaignTermsAndConditions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === _vm.CAMPAIGN_STEPS.T_AND_C),
      expression: "currentStep === CAMPAIGN_STEPS.T_AND_C"
    }],
    attrs: {
      "nextStep": _vm.nextStep,
      "campaignId": _vm.campaignId,
      "campaign": _vm.campaign
    }
  }), _vm._v(" "), _c('NewCampaignDevicesAndServices', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === _vm.CAMPAIGN_STEPS.EQUIPMENTS),
      expression: "currentStep === CAMPAIGN_STEPS.EQUIPMENTS"
    }],
    attrs: {
      "nextStep": _vm.nextStep,
      "previousStep": _vm.previousStep,
      "products": _vm.products,
      "campaignId": _vm.campaignId,
      "comesFromAnotherRoute": _vm.comesFromAnotherRoute,
      "comesFromAnotherRouteData": _vm.comesFromAnotherRouteData,
      "saveMethods": {
        setSaving: _vm.setSavingStatus,
        setSaved: _vm.setSavedStatus,
        performSave: _vm.performSave
      }
    }
  }), _vm._v(" "), _c('NewCampaignFinish', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentStep === _vm.CAMPAIGN_STEPS.FINISH),
      expression: "currentStep === CAMPAIGN_STEPS.FINISH"
    }],
    attrs: {
      "nextStep": _vm.nextStep,
      "campaignId": _vm.campaignId
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b15f6ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrganizationHome/NewCampaignInitialData.vue
// module id = 1734
// module chunks = 0